/**
 * ALO Matcha — Theme JavaScript
 * Vanilla ES6+ — No dependencies
 */

/* ==========================================================================
   SCROLL ANIMATIONS (IntersectionObserver)
   ========================================================================== */

(function() {
  var REVEAL_SELECTOR = '.animate-slide-up, .animate-fade, .animate-scale, .animate-blur, .animate-slide-left, .animate-slide-right, .stagger-children';
  var elements = document.querySelectorAll(REVEAL_SELECTOR);
  if (!elements.length) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    elements.forEach(function(el) {
      el.style.opacity = '1';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });
    return;
  }

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -50px 0px', threshold: 0.1 });

  elements.forEach(function(el) { observer.observe(el); });
})();

/* ==========================================================================
   STICKY HEADER
   - Adds .header--scrolled (blur + border) after 100px
   - Adds .header--hidden (slide up) on scroll down past 200px
   - Removes .header--hidden on scroll up
   ========================================================================== */

(function() {
  var header = document.querySelector('.header');
  if (!header) return;

  var lastScrollY = 0;
  var ticking = false;

  function updateHeader() {
    var scrollY = window.scrollY;

    if (scrollY > 24 && scrollY <= 120) {
      header.classList.add('header--lifted');
      header.classList.remove('header--scrolled');
    } else if (scrollY > 120) {
      header.classList.add('header--scrolled');
      header.classList.remove('header--lifted');
    } else {
      header.classList.remove('header--scrolled');
      header.classList.remove('header--lifted');
    }

    // Header stays visible at all scroll positions so the menu buttons
    // remain reachable. Hide-on-scroll-down disabled by request.
    header.classList.remove('header--hidden');

    lastScrollY = scrollY;
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) {
      window.requestAnimationFrame(updateHeader);
      ticking = true;
    }
  }, { passive: true });
})();

/* ==========================================================================
   MOBILE MENU — Slide-out drawer from left
   ========================================================================== */

(function() {
  var toggles = document.querySelectorAll('.js-menu-toggle');
  if (!toggles.length) return;

  var drawer = document.getElementById('MobileMenuDrawer');

  if (!drawer) {
    var nav = (window.themeStrings && window.themeStrings.navLinks) || {};
    var MN = (window.themeStrings && window.themeStrings.mobileNav) || {};
    var MENU = window.aloMobileMenu || {};
    function mmdProducts(items) { return (items || []).map(function(p) { return '<a href="' + p.u + '">' + p.t + '</a>'; }).join(''); }
    drawer = document.createElement('div');
    drawer.id = 'MobileMenuDrawer';
    drawer.className = 'mobile-menu-drawer';
    drawer.innerHTML =
      '<div class="mobile-menu-drawer__overlay"></div>' +
      '<div class="mobile-menu-drawer__inner">' +
        '<button class="mobile-menu-drawer__close js-menu-close" aria-label="' + ((window.themeStrings && window.themeStrings.close) || 'Close menu') + '">&times;</button>' +
        '<div class="mobile-menu-drawer__search">' +
          '<a href="/search" class="mobile-menu-drawer__search-btn">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
            '<span>' + ((window.themeStrings && window.themeStrings.searchLabel) || 'Search') + '</span>' +
          '</a>' +
        '</div>' +
        '<nav class="mobile-menu-drawer__nav">' +
          '<a href="/pages/about">' + (nav.about || 'About Us') + '</a>' +
          '<details class="mmd-group">' +
            '<summary><span>' + (MN.matcha || 'Matcha') + '</span><span class="mmd-chev" aria-hidden="true">+</span></summary>' +
            '<div class="mmd-sub">' +
              '<a href="/collections/matcha">' + (MN.allMatcha || 'All Matcha') + '</a>' +
              '<div class="mmd-subgroup">' +
                '<div class="mmd-subgroup__head">' +
                  '<a class="mmd-subgroup__title" href="/collections/bags">' + (MN.bags || 'Bags') + '</a>' +
                  '<button type="button" class="mmd-subgroup__toggle js-mmd-toggle" aria-expanded="false" aria-controls="mmd-bags" aria-label="' + (MN.showProducts || 'Show products') + '"><span class="mmd-pm" aria-hidden="true"></span></button>' +
                '</div>' +
                '<div class="mmd-acc">' +
                  '<div class="mmd-sub2" id="mmd-bags">' + mmdProducts(MENU.bags) +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div class="mmd-subgroup">' +
                '<div class="mmd-subgroup__head">' +
                  '<a class="mmd-subgroup__title" href="/collections/tins">' + (MN.tins || 'Tins') + '</a>' +
                  '<button type="button" class="mmd-subgroup__toggle js-mmd-toggle" aria-expanded="false" aria-controls="mmd-tins" aria-label="' + (MN.showProducts || 'Show products') + '"><span class="mmd-pm" aria-hidden="true"></span></button>' +
                '</div>' +
                '<div class="mmd-acc">' +
                  '<div class="mmd-sub2" id="mmd-tins">' + mmdProducts(MENU.tins) +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div class="mmd-subgroup">' +
                '<div class="mmd-subgroup__head">' +
                  '<a class="mmd-subgroup__title" href="/collections/box">' + (MN.sachetBoxes || 'Sachet Boxes') + '</a>' +
                  '<button type="button" class="mmd-subgroup__toggle js-mmd-toggle" aria-expanded="false" aria-controls="mmd-box" aria-label="' + (MN.showProducts || 'Show products') + '"><span class="mmd-pm" aria-hidden="true"></span></button>' +
                '</div>' +
                '<div class="mmd-acc">' +
                  '<div class="mmd-sub2" id="mmd-box">' + mmdProducts(MENU.box) +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<div class="mmd-subgroup">' +
                '<div class="mmd-subgroup__head">' +
                  '<a class="mmd-subgroup__title" href="/collections/for-him">' + (MN.forHim || 'For Him') + '</a>' +
                  '<button type="button" class="mmd-subgroup__toggle js-mmd-toggle" aria-expanded="false" aria-controls="mmd-forhim" aria-label="' + (MN.showProducts || 'Show products') + '"><span class="mmd-pm" aria-hidden="true"></span></button>' +
                '</div>' +
                '<div class="mmd-acc">' +
                  '<div class="mmd-sub2" id="mmd-forhim">' + mmdProducts(MENU.forhim) +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</details>' +
          '<details class="mmd-group">' +
            '<summary><span>' + (MN.bundles || 'Bundles') + '</span><span class="mmd-chev" aria-hidden="true">+</span></summary>' +
            '<div class="mmd-sub">' +
              '<a href="/collections/bundles">' + (MN.allBundles || 'All Bundles') + '</a>' +
              '<a href="/collections/gift-sets">' + (MN.giftSets || 'Gift Sets') + '</a>' +
              '<a href="/products/mens-ritual-bundle">' + (MN.mensRitualBundle || 'Men’s Ritual Bundle') + '</a>' +
            '</div>' +
          '</details>' +
          '<a href="/pages/for-him">' + (MN.forHim || 'For Him') + '</a>' +
          '<details class="mmd-group">' +
            '<summary><span>' + (MN.accessories || 'Accessories') + '</span><span class="mmd-chev" aria-hidden="true">+</span></summary>' +
            '<div class="mmd-sub">' +
              '<a href="/collections/accessories">' + (MN.allAccessories || 'All Accessories') + '</a>' +
              '<a href="/collections/exclusive">' + (MN.exclusive || 'Exclusive') + '</a>' +
              '<a href="/collections/bestsellers">' + (MN.bestsellers || 'Bestsellers') + '</a>' +
            '</div>' +
          '</details>' +
          '<details class="mmd-group">' +
            '<summary><span>' + (MN.lifestyleCommunity || 'Lifestyle &amp; Community') + '</span><span class="mmd-chev" aria-hidden="true">+</span></summary>' +
            '<div class="mmd-sub">' +
              '<a href="/blogs/journal">' + (MN.journal || 'Journal') + '</a>' +
              '<a href="/blogs/journal/tagged/recipes">' + (MN.recipes || 'Recipes') + '</a>' +
              '<a href="/blogs/journal/tagged/pilates">' + (MN.pilatesCommunity || 'Pilates Community') + '</a>' +
            '</div>' +
          '</details>' +
          '<a href="/pages/wholesale">' + (nav.wholesale || 'Wholesale') + '</a>' +
          '<a href="/pages/contact">' + (nav.contact || 'Contact Us') + '</a>' +
        '</nav>' +
        '<div class="mobile-menu-drawer__footer">' +
          /* Download Catalog button removed from mobile menu (client request, Oct 2026). */
          '<button class="mobile-menu-drawer__lang-btn js-mobile-lang-toggle">' +
            ((window.themeStrings && window.themeStrings.langLabel) || (document.documentElement.lang === 'ar' ? 'English' : 'العربية')) +
          '</button>' +
          /* Country + currency selectors removed: market is geo-locked, no manual switch. Language toggle kept. */
        '</div>' +
      '</div>';
    document.body.appendChild(drawer);

    var style = document.createElement('style');
    style.textContent =
      '.mobile-menu-drawer{position:fixed;inset:0;z-index:2000;pointer-events:none;visibility:hidden;transition:visibility .3s ease}' +
      '.mobile-menu-drawer.is-open{pointer-events:auto;visibility:visible}' +
      '.mobile-menu-drawer__overlay{position:absolute;inset:0;background:rgba(19,16,14,0.4);opacity:0;transition:opacity .3s ease}' +
      '.mobile-menu-drawer.is-open .mobile-menu-drawer__overlay{opacity:1}' +
      '.mobile-menu-drawer__inner{position:absolute;top:0;left:0;bottom:0;width:85%;max-width:380px;background:var(--color-cream,#fcf5e7);transform:translateX(-100%);transition:transform .3s ease;padding:3rem 2rem;overflow-y:auto}' +
      '.mobile-menu-drawer.is-open .mobile-menu-drawer__inner{transform:translateX(0)}' +
      '.mobile-menu-drawer__close{position:absolute;top:1.5rem;right:1.5rem;background:none!important;border:none!important;font-size:2rem;cursor:pointer;line-height:1;color:#215329;padding:4px!important;border-radius:0!important;transition:none}' +
      '.mobile-menu-drawer__close:hover{opacity:.7;transform:none!important}' +
      '.mobile-menu-drawer__search{margin-top:3rem;margin-bottom:0.5rem}' +
      '.mobile-menu-drawer__search-btn{display:flex;align-items:center;gap:0.75rem;padding:0.8rem 1.2rem;background:rgba(171,183,135,0.15);border-radius:var(--radius-pill,9999px);color:var(--color-olive,#4f6d50);text-decoration:none;font-size:0.95rem;transition:background .2s ease}' +
      '.mobile-menu-drawer__search-btn:hover{background:rgba(171,183,135,0.25);transform:none}' +
      '.mobile-menu-drawer__nav{display:flex;flex-direction:column;margin-top:1rem}' +
      '.mobile-menu-drawer__nav a{font-family:var(--font-heading,serif);font-size:1.5rem;padding:1rem 0;border-bottom:1px solid rgba(171,183,135,0.2);color:var(--color-black,#13100e);text-decoration:none}' +
      '.mobile-menu-drawer__nav a:hover{opacity:.6;transform:none}' +
      '.mmd-group{padding:0;margin:0;border-bottom:1px solid rgba(171,183,135,0.2)}' +
      '.mmd-group summary{list-style:none;cursor:pointer;display:flex;align-items:center;justify-content:space-between;font-family:var(--font-heading,serif);font-size:1.5rem;padding:1rem 0;color:var(--color-black,#13100e);outline:none}' +
      '.mmd-group summary::-webkit-details-marker{display:none}' +
      '.mmd-chev{font-family:var(--font-mono,monospace);font-size:1.2rem;color:var(--color-deep-green,#215329);transition:transform .25s ease;line-height:1;font-weight:400}' +
      '.mmd-group[open] > summary .mmd-chev{transform:rotate(45deg)}' +
      '.mmd-sub{display:flex;flex-direction:column;padding:0 0 0.85rem 0.85rem;gap:0.25rem;border-left:1px solid rgba(33,83,41,0.18);margin-left:0.4rem}' +
      '.mmd-sub > a{font-family:var(--font-body,sans-serif)!important;font-size:0.98rem!important;font-weight:500!important;padding:0.55rem 0 0.55rem 0.85rem!important;border-bottom:none!important;color:rgba(19,16,14,0.78)!important;text-decoration:none}' +
      '.mmd-sub > a:hover{color:var(--color-deep-green,#215329)!important;opacity:1!important}' +
      '.mmd-subgroup{padding:0;margin:0}' +
      '.mmd-subgroup__head{display:flex;align-items:center;justify-content:space-between;gap:0.4rem}' +
      '.mmd-subgroup__title{flex:1 1 auto;min-width:0;font-family:var(--font-body,sans-serif)!important;font-size:1rem!important;font-weight:600!important;padding:0.55rem 0.85rem!important;border-bottom:none!important;color:var(--color-black,#13100e)!important;text-decoration:none;line-height:1.3;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}' +
      '.mmd-subgroup__title:hover{color:var(--color-deep-green,#215329)!important;opacity:1!important;text-decoration:underline;text-underline-offset:3px;text-decoration-thickness:1px}' +
      '.mmd-subgroup__toggle{flex:0 0 auto;width:44px;height:44px;min-width:44px;display:flex;align-items:center;justify-content:center;background:none!important;border:none!important;padding:0!important;margin:0 -0.6rem 0 0;cursor:pointer;border-radius:0!important;transition:none;-webkit-tap-highlight-color:transparent}' +
      '.mmd-subgroup__toggle:hover{transform:none!important;opacity:1}' +
      '.mmd-pm{position:relative;width:14px;height:14px;display:block}' +
      '.mmd-pm::before,.mmd-pm::after{content:"";position:absolute;background:var(--color-deep-green,#215329)}' +
      '.mmd-pm::before{left:0;right:0;top:50%;height:1.5px;transform:translateY(-50%)}' +
      '.mmd-pm::after{top:0;bottom:0;left:50%;width:1.5px;transform:translateX(-50%);transition:transform .2s ease}' +
      '.mmd-subgroup.is-open .mmd-pm::after{transform:translateX(-50%) scaleY(0)}' +
      '.mmd-acc{display:grid;grid-template-rows:0fr;transition:grid-template-rows .2s ease}' +
      '.mmd-subgroup.is-open .mmd-acc{grid-template-rows:1fr}' +
      '.mmd-acc > .mmd-sub2{overflow:hidden;min-height:0}' +
      '.mmd-sub2{display:flex;flex-direction:column;padding:0 0 0.5rem 0.7rem;gap:0.1rem;border-left:1px solid rgba(33,83,41,0.14);margin-left:0.9rem}' +
      '.mmd-sub2 a{font-family:var(--font-body,sans-serif)!important;font-size:0.9rem!important;font-weight:400!important;padding:0.45rem 0 0.45rem 0.7rem!important;border-bottom:none!important;color:rgba(19,16,14,0.72)!important;text-decoration:none;line-height:1.3}' +
      '.mmd-sub2 a:hover{color:var(--color-deep-green,#215329)!important;opacity:1!important}' +
      '.mobile-menu-drawer__footer{margin-top:1.5rem;padding-top:0;padding-bottom:4rem;display:flex;flex-direction:column;align-items:flex-start;gap:0.85rem}' +
      '.mobile-menu-drawer__catalog{display:inline-flex;align-items:center;justify-content:center;gap:0.55rem;width:100%;padding:0.85rem 1.2rem;background:transparent;border:1px solid rgba(33,83,41,0.4);border-radius:9999px;color:var(--color-deep-green,#215329);font-family:var(--font-body,sans-serif);font-size:0.9rem;font-weight:600;letter-spacing:0.04em;text-decoration:none;transition:background .25s ease,color .25s ease,border-color .25s ease,transform .25s ease,box-shadow .25s ease}' +
      '.mobile-menu-drawer__catalog:hover,.mobile-menu-drawer__catalog:active{background:var(--color-deep-green,#215329);color:var(--color-cream,#fcf5e7);border-color:var(--color-deep-green,#215329);transform:translateY(-1px);box-shadow:0 10px 24px -14px rgba(33,83,41,0.45)}' +
      '.mobile-menu-drawer__catalog-icon{flex:0 0 auto;transition:transform .3s ease}' +
      '.mobile-menu-drawer__catalog:hover .mobile-menu-drawer__catalog-icon{transform:translateY(2px)}' +
      '.mobile-menu-drawer__lang-btn{background:transparent!important;border:1px solid var(--color-olive,#4f6d50)!important;border-radius:9999px!important;padding:10px 24px!important;font-family:var(--font-body,sans-serif);font-size:0.9rem;font-weight:500;color:var(--color-black,#13100e);cursor:pointer;transition:all .2s ease}' +
      '.mobile-menu-drawer__lang-btn:hover{background:var(--color-deep-green,#215329)!important;color:var(--color-cream,#fcf5e7)!important;transform:none!important}' +
      '.mobile-menu-drawer__ccy{display:flex;align-items:center;justify-content:space-between;gap:0.75rem;width:100%;padding:10px 18px;border:1px solid var(--color-olive,#4f6d50);border-radius:9999px;font-family:var(--font-body,sans-serif);font-size:0.9rem;font-weight:500;color:var(--color-black,#13100e)}' +
      '.mobile-menu-drawer__ccy select{appearance:none;-webkit-appearance:none;background:transparent;border:none;font-family:var(--font-body,sans-serif);font-size:0.9rem;font-weight:600;color:var(--color-deep-green,#215329);cursor:pointer;outline:none;text-align:right;padding-right:1.1rem;background-image:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23215329\' stroke-width=\'2\'><path d=\'M6 9l6 6 6-6\'/></svg>");background-repeat:no-repeat;background-position:right center;background-size:12px}' +
      '.mobile-menu-drawer__country{display:flex;align-items:center;justify-content:space-between;gap:0.75rem;width:100%;padding:10px 18px;border:1px solid var(--color-olive,#4f6d50);border-radius:9999px;font-family:var(--font-body,sans-serif);font-size:0.9rem;font-weight:500;color:var(--color-black,#13100e)}' +
      '.mobile-menu-drawer__country select{appearance:none;-webkit-appearance:none;background:transparent;border:none;font-family:var(--font-body,sans-serif);font-size:0.9rem;font-weight:600;color:var(--color-deep-green,#215329);cursor:pointer;outline:none;text-align:right;padding-right:1.1rem;max-width:62%;text-overflow:ellipsis;background-image:url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' viewBox=\'0 0 24 24\' fill=\'none\' stroke=\'%23215329\' stroke-width=\'2\'><path d=\'M6 9l6 6 6-6\'/></svg>");background-repeat:no-repeat;background-position:right center;background-size:12px}';
    document.head.appendChild(style);
  }

  // Native Shopify Markets country switch for the mobile drawer. Builds options from
  // window.aloMarkets (rendered in theme.liquid from localization.available_countries) and
  // submits Shopify's /localization form so the real market (and thus localization.country) changes.
  function buildCountrySelector(drawer) {
    var sel = drawer.querySelector('.js-country-select');
    var M = window.aloMarkets;
    var label = drawer.querySelector('.mobile-menu-drawer__country');
    if (!sel || !M || !M.countries || M.countries.length < 2) {
      if (label) label.style.display = 'none';
      return;
    }
    // Use the local DISPLAY currency per country (matches on-page prices), not the Shopify
    // market currency (USD for all). currency.js owns the country→currency map.
    var ccMap = (window.aloCurrency && window.aloCurrency.config && window.aloCurrency.config.countryToCurrency) || {};
    var ccRates = (window.aloCurrency && window.aloCurrency.config && window.aloCurrency.config.rates) || {};
    sel.innerHTML = M.countries.map(function (c) {
      var cur = ccMap[(c.iso || '').toUpperCase()];
      if (!cur || !ccRates[cur]) cur = 'USD';
      return '<option value="' + c.iso + '"' + (c.iso === M.current ? ' selected' : '') + '>' + c.name + ' (' + cur + ')</option>';
    }).join('');
    sel.addEventListener('change', function () {
      var root = (M.root && M.root.length) ? M.root : '/';
      if (root.charAt(root.length - 1) !== '/') root += '/';
      var f = document.createElement('form');
      f.method = 'POST';
      f.action = root + 'localization';
      f.style.display = 'none';
      function add(n, v) { var i = document.createElement('input'); i.type = 'hidden'; i.name = n; i.value = v; f.appendChild(i); }
      add('form_type', 'localization');
      add('utf8', '✓');
      add('_method', 'put'); // Shopify's localization route is a PUT; native {% form 'localization' %} adds this. Without it → 404.
      add('country_code', sel.value);
      add('locale_code', M.locale || document.documentElement.lang || 'en');
      add('return_to', window.location.pathname + window.location.search);
      document.body.appendChild(f);
      f.submit();
    });
  }

  function openMenu() {
    drawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    drawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  toggles.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openMenu();
    });
  });

  drawer.addEventListener('click', function(e) {
    if (e.target.classList.contains('mobile-menu-drawer__overlay') || e.target.classList.contains('js-menu-close')) {
      e.preventDefault();
      closeMenu();
    }
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeMenu();
    }
  });

  // Mobile language toggle
  drawer.addEventListener('click', function(e) {
    var langBtn = e.target.closest('.js-mobile-lang-toggle');
    if (langBtn) {
      e.preventDefault();
      switchLanguage();
    }
  });

  // Matcha sub-category split-action accordion — icon toggles only, one open at a time
  drawer.addEventListener('click', function(e) {
    var toggle = e.target.closest('.js-mmd-toggle');
    if (!toggle) return;
    e.preventDefault();
    var subgroup = toggle.closest('.mmd-subgroup');
    if (!subgroup) return;
    var willOpen = !subgroup.classList.contains('is-open');
    var container = subgroup.parentElement;
    if (container) {
      container.querySelectorAll(':scope > .mmd-subgroup.is-open').forEach(function(sg) {
        sg.classList.remove('is-open');
        var t = sg.querySelector('.mmd-subgroup__toggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }
    if (willOpen) {
      subgroup.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
    }
  });
})();

/* ==========================================================================
   SEARCH TRIGGER — navigates to /search
   ========================================================================== */

(function() {
  document.querySelectorAll('.js-search-trigger').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = ((window.aloMarkets && window.aloMarkets.root) || '/').replace(/\/+$/, '') + '/search';
    });
  });
})();

/* ==========================================================================
   CART (AJAX) — drawer + cart page
   - Per-variant debounce coalesces rapid +/- clicks into one /cart/change.js
   - DOM is patched in place (qty input value, line/total prices) — no full
     innerHTML rebuilds during quantity edits; full re-render only when a
     line is added or removed.
   - Server refresh is suppressed while pending changes are inflight, so
     stale server snapshots can't overwrite the user's latest local state.
   ========================================================================== */

// Global toast — used by add-to-cart errors + any future module needing feedback.
window.showAloToast = function(message, kind) {
  if (!message) return;
  var host = document.getElementById('aloToastHost');
  if (!host) {
    host = document.createElement('div');
    host.id = 'aloToastHost';
    host.className = 'alo-toast-host';
    document.body.appendChild(host);
  }
  var el = document.createElement('div');
  el.className = 'alo-toast alo-toast--' + (kind || 'info');
  el.setAttribute('role', kind === 'error' ? 'alert' : 'status');
  el.textContent = message;
  host.appendChild(el);
  requestAnimationFrame(function(){ el.classList.add('is-visible'); });
  setTimeout(function(){
    el.classList.remove('is-visible');
    setTimeout(function(){ if (el.parentNode) el.parentNode.removeChild(el); }, 350);
  }, 4200);
};

window.AloCart = (function() {
  var cartDrawer = document.getElementById('CartDrawer');

  var localCart = null;
  var pending = {};       // variantId -> { quantity, timer }
  var inflight = 0;
  var addInflight = 0;
  var DEBOUNCE_MS = 280;

  var cartCurrency = '';
  var cartCurrencySymbol = '$';

  function hasPending() {
    return inflight > 0 || addInflight > 0 || Object.keys(pending).length > 0;
  }

  function openCart() {
    if (!cartDrawer) return;
    if (!localCart) refreshCart();
    cartDrawer.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  function applyCurrency(cart) {
    if (!cart || !cart.currency) return;
    cartCurrency = cart.currency;
    var symbols = { USD: '$', EUR: '€', GBP: '£', AED: 'د.إ', SAR: '﷼', LBP: 'ل.ل', KWD: 'د.ك', BHD: 'د.ب', OMR: 'ر.ع', QAR: 'ر.ق' };
    cartCurrencySymbol = symbols[cart.currency] || cart.currency + ' ';
  }

  function refreshCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        applyCurrency(cart);
        // Drop the server snapshot if the user has more recent local edits
        // queued — applying it would flip the UI back to a stale quantity.
        if (hasPending()) return cart;
        var prev = localCart;
        localCart = cart;
        updateCartCount(cart.item_count);
        if (cartDrawer) {
          if (!prev || cartShapeChanged(prev, cart)) {
            renderDrawerFull(cart);
          } else {
            patchDrawer(cart);
          }
        }
        return cart;
      })
      .catch(function(err){ console.error('Cart refresh error:', err); });
  }

  function cartShapeChanged(a, b) {
    if (!a || !b) return true;
    if (a.items.length !== b.items.length) return true;
    for (var i = 0; i < a.items.length; i++) {
      if (String(a.items[i].key) !== String(b.items[i].key)) return true;
    }
    return false;
  }

  function recomputeTotals(cart) {
    cart.item_count = cart.items.reduce(function(s, it){ return s + it.quantity; }, 0);
    cart.total_price = cart.items.reduce(function(s, it){ return s + (it.final_price * it.quantity); }, 0);
  }

  // The quantity discount (2–4 matcha → 10%, 5+ matcha → 20%) is a Shopify
  // automatic discount scoped to the Matcha collection. Shopify computes which
  // line items qualify and reports the result in cart.js, so the drawer trusts
  // cart.total_discount / cart.total_price rather than guessing client-side
  // (a client guess would wrongly discount accessories / non-matcha items).
  function tierPreview(cart) {
    var fullSubtotal = cart.items.reduce(function(s, it){ return s + (it.final_price * it.quantity); }, 0);
    var discount = cart.total_discount || 0;
    var subtotal = (typeof cart.total_price === 'number') ? cart.total_price : (fullSubtotal - discount);
    return { subtotal: subtotal, discount: discount };
  }

  function updateSavingsRow(cart) {
    if (!cartDrawer) return;
    var row = cartDrawer.querySelector('[data-cart-savings]');
    if (!row) return;
    var disc = tierPreview(cart).discount;
    if (disc > 0) {
      row.hidden = false;
      var amt = row.querySelector('[data-cart-savings-amount]');
      if (amt) amt.textContent = '−' + formatMoney(disc);
    } else {
      row.hidden = true;
    }
  }

  // Drawer subtotal that reflects the tier preview.
  function drawerSubtotal(cart) {
    return tierPreview(cart).subtotal;
  }

  function updateCartCount(count) {
    document.querySelectorAll('.header__cart-count').forEach(function(el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
    document.querySelectorAll('.header__cart-badge').forEach(function(el) {
      el.textContent = count;
      if (count > 0) { el.removeAttribute('hidden'); }
      else { el.setAttribute('hidden', ''); }
    });
  }

  function getSizedImageUrl(url, size) {
    if (!url) return '';
    var match = url.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif|webp)(\?v=\d+)?$/i);
    if (match) {
      var prefix = url.split(match[0]);
      return prefix[0] + '_' + size + '.' + match[1] + (match[2] || '');
    }
    return url;
  }

  function formatMoney(cents) {
    if (window.aloCurrency) return window.aloCurrency.format(cents);
    var amount = (Math.round(cents) / 100).toFixed(2);
    return cartCurrencySymbol + amount + (cartCurrency ? ' ' + cartCurrency : '');
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function attrSelector(value) {
    return String(value).replace(/(["\\])/g, '\\$1');
  }

  function buildItemHtml(item) {
    var img = item.image ? getSizedImageUrl(item.image, '160x') : '';
    return '<div class="cart-item" data-key="' + escapeHtml(item.key) + '">' +
      '<a href="' + escapeHtml(item.url) + '" class="cart-item__image-link">' +
        '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(item.product_title || item.title) + '" class="cart-item__image">' +
      '</a>' +
      '<div class="cart-item__details">' +
        '<a href="' + escapeHtml(item.url) + '" class="cart-item__title">' + escapeHtml(item.product_title) + '</a>' +
        (item.variant_title ? '<p class="cart-item__variant">' + escapeHtml(item.variant_title) + '</p>' : '') +
        '<div class="cart-item__price">' + formatMoney(item.final_price) + '</div>' +
        '<div class="cart-item__quantity">' +
          '<button type="button" class="cart-item__qty-btn" data-key="' + escapeHtml(item.key) + '" data-delta="-1" aria-label="' + ((window.cartStrings && window.cartStrings.decreaseQty) || 'Decrease quantity') + '">' +
            '<svg viewBox="0 0 14 14" aria-hidden="true"><line x1="2" y1="7" x2="12" y2="7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
          '<input type="number" class="cart-item__qty-input" value="' + item.quantity + '" min="0" readonly tabindex="-1">' +
          '<button type="button" class="cart-item__qty-btn" data-key="' + escapeHtml(item.key) + '" data-delta="1" aria-label="' + ((window.cartStrings && window.cartStrings.increaseQty) || 'Increase quantity') + '">' +
            '<svg viewBox="0 0 14 14" aria-hidden="true"><line x1="2" y1="7" x2="12" y2="7" stroke="currentColor" stroke-width="2" stroke-linecap="round"/><line x1="7" y1="2" x2="7" y2="12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function renderDrawerEmpty() {
    if (!cartDrawer) return;
    var body = cartDrawer.querySelector('.cart-drawer__body');
    var footer = cartDrawer.querySelector('.cart-drawer__footer');
    var strings = window.cartStrings || {};
    if (body) body.innerHTML = '<div class="cart-drawer__empty"><p>' + escapeHtml(strings.empty || 'Your cart is empty.') + '</p><a href="/collections/all" class="button">' + escapeHtml(strings.startShopping || 'Start Shopping') + '</a></div>';
    if (footer) footer.style.display = 'none';
  }

  function renderDrawerFull(cart) {
    if (!cartDrawer) return;
    var body = cartDrawer.querySelector('.cart-drawer__body');
    var footer = cartDrawer.querySelector('.cart-drawer__footer');
    if (!body) return;
    var visible = cart.items.filter(function(it){ return it.quantity > 0; });
    if (!visible.length) { renderDrawerEmpty(); return; }
    var html = '<div class="cart-drawer__items">';
    visible.forEach(function(item){ html += buildItemHtml(item); });
    html += '</div>';
    body.innerHTML = html;
    if (footer) {
      footer.style.display = '';
      var sub = footer.querySelector('.cart-drawer__subtotal span:last-child');
      if (sub) sub.textContent = formatMoney(drawerSubtotal(cart));
      updateSavingsRow(cart);
    }
  }

  function patchDrawer(cart) {
    if (!cartDrawer) return;
    cart.items.forEach(function(item){
      var line = cartDrawer.querySelector('.cart-item[data-key="' + attrSelector(item.key) + '"]');
      if (!line) return;
      var input = line.querySelector('.cart-item__qty-input');
      if (input && String(input.value) !== String(item.quantity)) input.value = item.quantity;
      var priceEl = line.querySelector('.cart-item__price');
      if (priceEl) priceEl.textContent = formatMoney(item.final_price);
    });
    var footer = cartDrawer.querySelector('.cart-drawer__footer');
    if (footer) {
      var sub = footer.querySelector('.cart-drawer__subtotal span:last-child');
      if (sub) sub.textContent = formatMoney(drawerSubtotal(cart));
      updateSavingsRow(cart);
    }
  }

  function patchDrawerLineQty(key, qty) {
    if (!cartDrawer) return;
    var line = cartDrawer.querySelector('.cart-item[data-key="' + attrSelector(key) + '"]');
    if (!line) return;
    var input = line.querySelector('.cart-item__qty-input');
    if (input) input.value = qty;
  }

  function removeDrawerLine(key) {
    if (!cartDrawer) return;
    var line = cartDrawer.querySelector('.cart-item[data-key="' + attrSelector(key) + '"]');
    if (line && line.parentNode) line.parentNode.removeChild(line);
  }

  function patchDrawerSubtotal(cart) {
    if (!cartDrawer) return;
    var footer = cartDrawer.querySelector('.cart-drawer__footer');
    if (!footer) return;
    var sub = footer.querySelector('.cart-drawer__subtotal span:last-child');
    if (sub) sub.textContent = formatMoney(drawerSubtotal(cart));
    updateSavingsRow(cart);
  }

  // ---- cart-page (full /cart) DOM patches ---------------------------------

  function patchCartPageLine(key, qty, lineTotalCents) {
    document.querySelectorAll('.cart-page__item[data-key="' + attrSelector(key) + '"]').forEach(function(row){
      var input = row.querySelector('.product-main__qty-input');
      if (input && String(input.value) !== String(qty)) input.value = qty;
      var totalEl = row.querySelector('.cart-page__line-price');
      if (totalEl) totalEl.textContent = formatMoney(lineTotalCents);
    });
  }

  function removeCartPageLine(key) {
    document.querySelectorAll('.cart-page__item[data-key="' + attrSelector(key) + '"]').forEach(function(row){
      if (row.parentNode) row.parentNode.removeChild(row);
    });
  }

  function patchCartPageSubtotal(cart) {
    document.querySelectorAll('.cart-page__subtotal span:last-child').forEach(function(el){
      el.textContent = formatMoney(drawerSubtotal(cart));
    });
    if (cart.item_count === 0) {
      var form = document.querySelector('.cart-page__form');
      if (form) {
        var strings = window.cartStrings || {};
        var empty = document.createElement('div');
        empty.className = 'cart-page__empty';
        empty.innerHTML = '<p>' + escapeHtml(strings.empty || 'Your cart is empty.') + '</p><a href="/collections/all" class="button">' + escapeHtml(strings.startShopping || 'Start Shopping') + '</a>';
        form.parentNode.replaceChild(empty, form);
      }
    }
  }

  // ---- core change pipeline ------------------------------------------------

  function findItem(cart, key) {
    if (!cart) return null;
    for (var i = 0; i < cart.items.length; i++) {
      if (String(cart.items[i].key) === String(key)) return cart.items[i];
    }
    return null;
  }

  function schedulePending(variantId, qty) {
    if (pending[variantId]) clearTimeout(pending[variantId].timer);
    pending[variantId] = {
      quantity: qty,
      timer: setTimeout(function(){ flushPending(variantId); }, DEBOUNCE_MS)
    };
  }

  function flushPending(variantId) {
    var entry = pending[variantId];
    if (!entry) return;
    var qty = entry.quantity;
    delete pending[variantId];
    inflight++;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
    .then(function(r){ if (!r.ok) throw new Error('cart change failed'); return r.json(); })
    .catch(function(err){ console.error('Cart change error:', err); })
    .then(function(){
      inflight--;
      if (!hasPending()) refreshCart();
    });
  }

  function changeByKey(key, delta) {
    if (!localCart) {
      refreshCart().then(function(){ changeByKey(key, delta); });
      return;
    }
    var item = findItem(localCart, key);
    if (!item) return;
    var variantId = String(item.variant_id);
    var newQty = Math.max(0, item.quantity + delta);
    var lineTotal;

    if (newQty === 0) {
      localCart.items = localCart.items.filter(function(it){ return String(it.key) !== String(key); });
      removeDrawerLine(key);
      removeCartPageLine(key);
    } else {
      item.quantity = newQty;
      lineTotal = item.final_price * newQty;
      patchDrawerLineQty(key, newQty);
      patchCartPageLine(key, newQty, lineTotal);
    }

    recomputeTotals(localCart);
    updateCartCount(localCart.item_count);
    if (localCart.item_count === 0) {
      renderDrawerEmpty();
      patchCartPageSubtotal(localCart);
    } else {
      patchDrawerSubtotal(localCart);
      patchCartPageSubtotal(localCart);
    }

    // Test-mode items live only in localCart; never sync them to /cart/change.js
    // (would 404 and trigger refreshCart that wipes the fake item).
    if (String(key).indexOf('test-') === 0) return;
    schedulePending(variantId, newQty);
  }

  // ---- event wiring --------------------------------------------------------

  document.querySelectorAll('.js-cart-trigger').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      openCart();
    });
  });

  document.querySelectorAll('.js-cart-close').forEach(function(btn) {
    btn.addEventListener('click', closeCart);
  });

  if (cartDrawer) {
    cartDrawer.addEventListener('click', function(e) {
      if (e.target === cartDrawer || e.target.classList.contains('cart-drawer__overlay')) {
        closeCart();
      }
    });

    cartDrawer.addEventListener('click', function(e) {
      var btn = e.target.closest('.cart-item__qty-btn');
      if (!btn) return;
      e.preventDefault();
      var key = btn.dataset.key;
      var delta = parseInt(btn.dataset.delta) || 0;
      if (key && delta) changeByKey(key, delta);
    });
  }

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('is-open')) closeCart();
  });

  // Cart page: quantity buttons + remove links (delegated, AJAX)
  document.addEventListener('click', function(e) {
    var qtyBtn = e.target.closest('.cart-page__item .product-main__qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      var row = qtyBtn.closest('.cart-page__item');
      if (!row || !row.dataset.key) return;
      var delta = parseInt(qtyBtn.dataset.delta) || 0;
      if (delta) changeByKey(row.dataset.key, delta);
      return;
    }
    var removeLink = e.target.closest('.cart-page__remove');
    if (removeLink) {
      e.preventDefault();
      var row2 = removeLink.closest('.cart-page__item');
      if (!row2 || !row2.dataset.key) return;
      var current = findItem(localCart, row2.dataset.key);
      if (current) changeByKey(row2.dataset.key, -current.quantity);
    }
  });

  // Block the cart page form's native submit (it would full-reload). The
  // checkout button still navigates because it has its own handler below.
  var cartPageForm = document.querySelector('.cart-page__form');
  if (cartPageForm) {
    cartPageForm.addEventListener('submit', function(e) {
      var submitter = e.submitter;
      if (submitter && submitter.name === 'checkout') return; // allow checkout
      e.preventDefault();
    });
  }

  // Add-to-cart forms — fetch first, then refresh + open. No fake optimistic
  // line (which would carry wrong price/title until the server caught up).
  // Catches every form posting to /cart/add. Sections (offer-sticky etc.)
  // that own the submit can call e.preventDefault first to opt out.
  document.addEventListener('submit', function(e) {
    if (e.defaultPrevented) return;
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '').split('?')[0];
    var isCartAdd =
      action === '/cart/add' ||
      action.endsWith('/cart/add') ||
      form.matches('.product-card__form, .product-form, .pairs-item__form, .fh-bundle__form');
    if (!isCartAdd) return;
    e.preventDefault();

    var fd = new FormData(form);
    if (!fd.get('id')) return;

    var submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      if (submitBtn.classList.contains('product-card__quick-add') || submitBtn.classList.contains('product-main__add')) submitBtn.classList.add('is-loading');
    }

    addInflight++;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: fd
    })
      .then(function(r){
        if (!r.ok) return r.json().then(function(j){ throw j; });
        return r.json();
      })
      .then(function(){
        addInflight--;
        document.dispatchEvent(new CustomEvent('alo:cart:added', { detail: { form: form } }));
        return refreshCart().then(function(){
          openCart();
          document.dispatchEvent(new CustomEvent('alo:cart:updated'));
        });
      })
      .catch(function(err){
        addInflight--;
        console.warn('Add to cart server error (test-mode swallow):', err);
        // TEST MODE — Shopify rejected (sold out etc.). Build a fake line item
        // from the form's dataset so the drawer still shows the product. Cart
        // remains empty server-side; this is UI-only and will be reverted.
        var ds = form.dataset || {};
        var variantId = String(fd.get('id') || ds.variantId || Math.random().toString(36).slice(2));
        var qty = parseInt(fd.get('quantity'), 10) || 1;
        var priceCents = parseInt(ds.price, 10);
        if (isNaN(priceCents)) priceCents = 0;
        var fakeItem = {
          key: 'test-' + variantId + '-' + Date.now(),
          id: Number(variantId) || variantId,
          product_id: ds.productId || variantId,
          product_title: ds.title || form.querySelector('[data-title]') && form.querySelector('[data-title]').textContent || 'Product',
          title: ds.title || 'Product',
          variant_title: '',
          url: ds.url || '#',
          image: ds.image || '',
          quantity: qty,
          final_price: priceCents,
          line_price: priceCents * qty,
          original_price: priceCents,
          price: priceCents
        };
        if (!localCart || !localCart.items) {
          localCart = { items: [], item_count: 0, total_price: 0, currency: cartCurrency || 'USD' };
        }
        localCart.items.push(fakeItem);
        recomputeTotals(localCart);
        updateCartCount(localCart.item_count);
        if (cartDrawer) renderDrawerFull(localCart);
        document.dispatchEvent(new CustomEvent('alo:cart:added', { detail: { form: form } }));
        showAloToast('Test mode — UI simulated (cart server-side empty).', 'info');
        openCart();
        document.dispatchEvent(new CustomEvent('alo:cart:updated'));
      })
      .then(function(){
        if (submitBtn) submitBtn.disabled = false;
      });
  });

  // Initial state. Skip the forced re-render if the server already rendered
  // a current drawer body (avoids a flash on page load).
  refreshCart();

  // Brief success pulse on the quick-add button after AJAX add.
  document.addEventListener('alo:cart:added', function(e){
    var form = e.detail && e.detail.form;
    if (!form) return;
    var btn = form.querySelector('.product-card__quick-add, .cart-rec__add, .pairs-item__btn, .fh-bundle__btn, .js-add-to-cart');
    if (!btn) return;
    btn.classList.remove('is-loading');
    btn.classList.add('is-success');
    setTimeout(function(){ btn.classList.remove('is-success'); }, 800);
  });
  document.addEventListener('alo:cart:error', function(e){
    var form = e.detail && e.detail.form;
    if (!form) return;
    var btn = form.querySelector('.product-card__quick-add, .cart-rec__add, .pairs-item__btn, .fh-bundle__btn, .js-add-to-cart');
    if (btn) btn.classList.remove('is-loading');
  });

  // Stop add-to-cart button clicks from bubbling into wrapping <a> (product card)
  // which would otherwise navigate away before the AJAX call could fire.
  document.addEventListener('click', function(e){
    var btn = e.target.closest('.js-add-to-cart, .product-card__quick-add, .pairs-item__btn, .fh-bundle__btn');
    if (!btn) return;
    // Only stop bubbling if the button lives inside a real submit form. Buttons
    // outside forms (variant-required fallbacks) keep their default behavior.
    if (btn.closest('form[action$="/cart/add"]')) {
      e.stopPropagation();
    }
  }, true);

  /* ------------------------------------------------------------------
     Cart drawer — "You May Also Like" recommendations
     Lazy-loaded when the drawer opens. Falls back to featured/best products
     when Shopify's product-based recommendations endpoint returns nothing.
     ------------------------------------------------------------------ */
  var recsLoaded = false;
  var recsLoading = false;

  function formatMoneyCents(cents) {
    if (cents == null || isNaN(cents)) return '';
    if (window.aloCurrency) return window.aloCurrency.format(cents);
    var amount = (cents / 100).toFixed(2);
    return (cartCurrencySymbol || '$') + amount;
  }

  function renderRecommendations(products) {
    var host = document.getElementById('cartRecs');
    if (!host) return;
    if (!products || !products.length) { host.hidden = true; return; }
    var html = '<div class="cart-recs__head"><h3 class="cart-recs__title">' + ((window.cartStrings && window.cartStrings.youMayAlsoLike) || 'You May Also Like') + '</h3></div>';
    html += '<div class="cart-recs__track" role="list">';
    products.slice(0, 4).forEach(function(p){
      var v = (p.variants || [])[0];
      if (!v) return;
      var img = (p.featured_image || (p.images && p.images[0])) || '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var imgSrc = img ? (img.split('?')[0] + '?width=180') : '';
      var url = p.url || ('/products/' + p.handle);
      var price = (v.price != null) ? formatMoneyCents(v.price) : '';
      html +=
        '<div class="cart-rec" role="listitem">' +
          '<a class="cart-rec__media" href="' + url + '" aria-label="' + escapeHtml(p.title) + '">' +
            (imgSrc ? '<img loading="lazy" src="' + imgSrc + '" alt="' + escapeHtml(p.title) + '">' : '') +
          '</a>' +
          '<div class="cart-rec__body">' +
            '<a class="cart-rec__title" href="' + url + '">' + escapeHtml(p.title) + '</a>' +
            '<span class="cart-rec__price">' + price + '</span>' +
          '</div>' +
          '<form method="post" action="/cart/add" class="cart-rec__form product-card__form" data-rec-form>' +
            '<input type="hidden" name="id" value="' + v.id + '">' +
            '<input type="hidden" name="quantity" value="1">' +
            '<button type="submit" class="cart-rec__add js-add-to-cart" aria-label="' + ((window.cartStrings && window.cartStrings.addToCart) || 'Add to cart') + '">' +
              '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>' +
            '</button>' +
          '</form>' +
        '</div>';
    });
    html += '</div>';
    host.innerHTML = html;
    host.hidden = false;
  }

  function fetchRecommendations() {
    if (recsLoaded || recsLoading) return;
    var host = document.getElementById('cartRecs');
    if (!host) return;
    recsLoading = true;

    var firstItem = localCart && localCart.items && localCart.items[0];
    var productId = firstItem && firstItem.product_id;

    var primary = productId
      ? fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related', { credentials: 'same-origin' })
          .then(function(r){ return r.ok ? r.json() : { products: [] }; })
          .then(function(d){ return (d && d.products) || []; })
          .catch(function(){ return []; })
      : Promise.resolve([]);

    function finalize(products) {
      renderRecommendations(products || []);
      recsLoaded = true; recsLoading = false;
    }

    // Last-resort fallback: fetch a few known product handles directly.
    // Single-product endpoints succeed under store-password gates where
    // /products.json may return HTML.
    function fetchKnownHandles() {
      var handles = ['alo-matcha', 'blue-matcha', 'acai-matcha', 'alo-matcha-gift-set', 'ceremonial-whisk', 'matcha-bowl'];
      return Promise.all(handles.map(function(h){
        return fetch('/products/' + h + '.js', { credentials: 'same-origin' })
          .then(function(r){ return r.ok ? r.json() : null; })
          .catch(function(){ return null; });
      })).then(function(arr){ return arr.filter(Boolean).slice(0, 4); });
    }

    primary.then(function(products){
      if (products && products.length) { finalize(products); return; }
      fetch('/products.json?limit=8', { credentials: 'same-origin' })
        .then(function(r){ return r.ok ? r.json() : { products: [] }; })
        .then(function(d){
          var list = (d && d.products) || [];
          var inCart = {};
          (localCart && localCart.items || []).forEach(function(it){ inCart[it.product_id] = true; });
          list = list.filter(function(p){ return !inCart[p.id]; }).slice(0, 4);
          if (list.length) { finalize(list); return; }
          fetchKnownHandles().then(finalize);
        })
        .catch(function(){ fetchKnownHandles().then(finalize); });
    });
  }

  // Trigger recommendations on drawer open + when cart updates.
  document.addEventListener('alo:cart:opened', function(){
    fetchRecommendations();
  });
  // Wrap openCart so we can fire the event.
  var _openCart = openCart;
  openCart = function() {
    _openCart();
    document.dispatchEvent(new CustomEvent('alo:cart:opened'));
  };
  // Hide recs row when cart truly becomes empty (server cart removed last item).
  // Skip hide if any item is a test-mode injection so the drawer keeps its UI.
  document.addEventListener('alo:cart:updated', function(){
    var host = document.getElementById('cartRecs');
    if (!host) return;
    var hasTestItem = (localCart && localCart.items || []).some(function(it){
      return String(it.key || '').indexOf('test-') === 0;
    });
    if (hasTestItem) return;
    if (!localCart || localCart.item_count === 0) host.hidden = true;
  });

  return { open: openCart, close: closeCart, refresh: refreshCart, change: changeByKey };
})();

/* ==========================================================================
   LANGUAGE TOGGLE (EN ↔ AR)
   Uses form submission with fallback to URL redirect
   ========================================================================== */

function switchLanguage() {
  var currentLang = document.documentElement.lang || 'en';
  var newLang = currentLang === 'ar' ? 'en' : 'ar';

  // Try form submission first
  var form = document.querySelector('form[action*="/localization"]');
  if (form) {
    var input = form.querySelector('input[name="locale_code"]');
    if (input) {
      input.value = newLang;
      form.submit();
      return;
    }
  }

  // Fallback: URL redirect
  var path = window.location.pathname;
  if (currentLang === 'ar') {
    // Remove /ar prefix
    path = path.replace(/^\/ar(\/|$)/, '/');
  } else {
    // Add /ar prefix
    path = '/ar' + (path === '/' ? '' : path);
  }
  window.location.href = path + window.location.search;
}

/* switchLanguage() is invoked by the mobile drawer's .js-mobile-lang-toggle (see menu init).
   Header switcher uses its own .js-lang-set handler in header.liquid. */

/* ==========================================================================
   LOCALE LINK GUARD
   Hardcoded root-relative links (drawer nav, section CTAs) don't carry the
   /ar prefix, so following them silently drops the visitor back to English.
   Rewrite such links at click time to stay inside the current locale.
   ========================================================================== */
(function () {
  var root = (window.aloMarkets && window.aloMarkets.root) || '/';
  if (root === '/') return; // default locale — nothing to rewrite
  var prefix = root.replace(/\/+$/, ''); // '/ar'
  // Paths Shopify serves outside the locale tree — never prefix these.
  var SKIP = /^\/(cdn\/|admin|checkout|discount\/|apps\/|services\/|tools\/|payments\/|wallets\/|cart\/c\/|\.well-known\/)/;
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="/"]') : null;
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href === prefix || href.indexOf(prefix + '/') === 0 || SKIP.test(href)) return;
    a.setAttribute('href', prefix + href);
  }, true);
})();

/* ==========================================================================
   FAQ ACCORDION
   ========================================================================== */

(function() {
  document.querySelectorAll('.faq-item__question').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var item = btn.closest('.faq-item');
      if (!item) return;
      var isOpen = item.classList.contains('is-open');
      document.querySelectorAll('.faq-item.is-open').forEach(function(openItem) {
        if (openItem !== item) openItem.classList.remove('is-open');
      });
      item.classList.toggle('is-open', !isOpen);
    });
  });
})();
